import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';
import { FormGroup } from '../../../common-components';
import messages from '../../messages';

const EducationLevelField = (props) => {
  const { formatMessage } = useIntl();
  const {
    value,
    handleChange,
    handleErrorChange,
    errorMessage,
    required = true,
    name = 'education_level',
  } = props;

  const OPTIONS = [
    { value: '', label: formatMessage(messages['registration.education_level.label']) },
    { value: 'hs', label: formatMessage(messages['education.level.hs']) },
    { value: 'ug', label: formatMessage(messages['education.level.ug']) },
    { value: 'm', label: formatMessage(messages['education.level.m']) },
    { value: 'd', label: formatMessage(messages['education.level.d']) },
    { value: 'other', label: formatMessage(messages['education.level.other']) },
  ];

  const handleOnChange = (e) => {
    handleChange({ target: { name, value: e.target.value } });
    if (errorMessage) handleErrorChange(name, '');
  };

  const handleOnBlur = (e) => {
    if (required && !e.target.value) {
      handleErrorChange(
        name,
        formatMessage(messages['empty.education_level.field.error'])
      );
    }
  };

  const handleOnFocus = () => {
    handleErrorChange(name, '');
  };

  const renderOptions = () => (
    <>
      {OPTIONS.map((opt, index) => (
        <option
          key={opt.value || index}
          value={opt.value}
          disabled={opt.value === ''}
          hidden={opt.value === '' && value !== ''}
        >
          {opt.label}
        </option>
      ))}
    </>
  );

  return (
    <FormGroup
      as="select"
      name={name}
      value={value}
      handleChange={handleOnChange}
      handleBlur={handleOnBlur}
      handleFocus={handleOnFocus}
      errorMessage={errorMessage}
      floatingLabel={formatMessage(messages['registration.education_level.label'])}
      options={renderOptions}
    />
  );
};

EducationLevelField.propTypes = {
  value: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string,
};

EducationLevelField.defaultProps = {
  value: '',
  errorMessage: '',
};

export default EducationLevelField;
